export const preview = [
  {
    path: '/preview',
    component: () => import(/* webpackChunkName: "preview" */ '@/views/preview/Preview.vue'),
    meta: {
      app: 'individual',
    },
    children: [
      {
        path: 'itinerary/:token',
        component: () => import(/* webpackChunkName: "preview" */ '@/views/preview/components/PreviewItinerary'),
      },
      {
        path: 'session/:token',
        component: () => import(/* webpackChunkName: "preview" */ '@/views/preview/components/PreviewSession'),
      },
    ]
  },
]
